import React from 'react';
import { Box, Typography } from '@mui/material';

const LightBlueCard = ({ label, value }: { label: string; value: string }) => {
  return (
    <div style={{ width: '100%' }}>
      <Box
        sx={{
          backgroundColor: '#5BC2E740',
          padding: '0.625rem 0',
          borderRadius: '0.9375rem',
          width: '100%',
          display: 'flex',
          justifyContent: 'space-between'
        }}
      >
        <Typography
          sx={{
            color: '#002A3A',
            fontWeight: 450,
            fontSize: '1.5rem',
            lineHeight: '1.75rem',
            marginLeft: '0.625rem'
          }}
        >
          {label}
        </Typography>
        <Typography
          sx={{
            color: '#007ACC',
            fontWeight: 450,
            fontSize: '1.5rem',
            lineHeight: '1.75rem',
            marginRight: '0.625rem'
          }}
        >
          {value}
        </Typography>
      </Box>
    </div>
  );
};

export default LightBlueCard;
